'use client';
import SideNav from 'Layout/SideNav';
import { CertificationWizard } from './components/certification-wizard';
import { CertificationProvider } from './contexts/certification-context';
import { Layout } from 'antd';
import HeaderBar from 'Layout/HeaderBar';
import BlurOverlayContainer from 'components/Overlay/BlurOverlayContainer';
import { FeatureIds } from 'modules/featureControl/featuresConfig';
import FooterBar from 'Layout/FooterBar';

export default function CertificationProcess() {
  return (
    <>
      <SideNav />
      <Layout style={{ backgroundColor: '#fcfcfc' }}>
        <HeaderBar />
        <BlurOverlayContainer featureKey={FeatureIds.CERTIFICATION}>
          <Layout.Content style={{ margin: '24px 24px 0' }}>
            <>
              <main className="container mx-auto">
                {/* <h1 className="text-3xl font-bold text-center mb-8">Certification Process</h1> */}
                <div className="w-full mx-auto">
                  <CertificationProvider>
                    <CertificationWizard />
                  </CertificationProvider>
                </div>
              </main>
            </>
          </Layout.Content>
        </BlurOverlayContainer>
        <FooterBar />
      </Layout>
    </>
  );
}
